export { DomainKeyClassificationStrategy } from './strategy';
export type { DomainKeyClassificationRule } from './rule';
